/**
 * Controle de versão da aplicação.
 * Fonte única para validar qual build está publicado (ex.: no rodapé).
 * Estágio: beta | rc | stable
 */
export const APP_VERSION = '1.0.0';
export const APP_STAGE = 'stable';

/** Texto curto para exibição: "1.0.0 (stable)" */
export const VERSION_LABEL = `${APP_VERSION} (${APP_STAGE})`;
